// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/current/uiwidgets/selected-zones/';
export const actions = [
  'DECREASE_LOCK_COUNT',
  'INCREASE_LOCK_COUNT'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});


// Reducer
export default function reducer(
  state = {},
  action = {}
) {

  switch (action.type) {
    case actions.INCREASE_LOCK_COUNT:
      return {
        ...state,
        [action.payload.key]: state[action.payload.key] + 1 || 1
      };
    case actions.DECREASE_LOCK_COUNT:
      return {
        ...state,
        [action.payload.key]:  state[action.payload.key] ? state[action.payload.key] - 1 : 0
      }; // Don't go negative
    default:
      return state;
  }
}

// Action creators
export const _addLock = (key) => {
  return {
    type: actions.INCREASE_LOCK_COUNT,
    payload: { key }
  };
};

export const _removeLock = (key) => {
  return {
    type: actions.DECREASE_LOCK_COUNT,
    payload: { key }
  };
};

export const lockPlantingPlan = () => {
  return _addLock('plantingPlan');
};

export const unlockPlantingPlan = () => {
  return _removeLock('plantingPlan');
};

export const lockSaveTrigger = () => {
  return _addLock('saveTrigger');
};

export const unlockSaveTrigger = () => {
  return _removeLock('saveTrigger');
};
